import React, { useEffect, useState } from 'react';
import { getOrder } from '../api';
import { Link, useParams } from 'react-router-dom';

function OrderPage() {
    const headerCellStyle = {
        textAlign: 'left',
        padding: '12px',
        borderBottom: '1px solid #e5e7eb',
        fontWeight: 'bold',
        color: '#374151',
        background: '#f9fafb'
    };

    const cellStyle = {
        padding: '12px',
        borderBottom: '1px solid #f1f5f9',
        color: '#111827'
    };

    const token = localStorage.getItem('token');
    const { orderId } = useParams();
    const [orderData, setOrderData] = useState(null);
    const [message, setMessage] = useState('');

    const fetchOrder = async () => {
        setMessage('');
        const data = await getOrder(token, orderId);
        if (data.order_id) {
            setOrderData(data);
        } else {
            setMessage(data.message || 'Заказ не найден');
        }
    };

    useEffect(() => {
        fetchOrder();
        // eslint-disable-next-line
    }, [orderId]);

    useEffect(() => {
        if (!orderData || orderData.status !== 'Обработка данных') {
            return;
        }

        const intervalId = setInterval(() => {
            fetchOrder();
        }, 2000);

        return () => clearInterval(intervalId);
        // eslint-disable-next-line
    }, [orderData?.status, orderId]);

    const getStatusLabelStyle = (status) => {
        const value = (status || '').toLowerCase();

        if (value.includes('обработка')) {
            return {
                background: '#fef3c7',
                color: '#92400e'
            };
        }

        if (value.includes('заплан')) {
            return {
                background: '#dbeafe',
                color: '#1d4ed8'
            };
        }

        if (value.includes('передано')) {
            return {
                background: '#ede9fe',
                color: '#6d28d9'
            };
        }

        return {
            background: '#e5e7eb',
            color: '#374151'
        };
    };

    if (message) {
        return (
            <div style={{ padding: '24px' }}>
                <div style={{ maxWidth: '1100px', margin: '0 auto' }}>
                    <div
                        style={{
                            background: '#fff',
                            borderRadius: '18px',
                            padding: '24px',
                            boxShadow: '0 10px 24px rgba(15, 23, 42, 0.06)'
                        }}
                    >
                        {message}
                    </div>
                </div>
            </div>
        );
    }

    if (!orderData) {
        return (
            <div style={{ padding: '24px' }}>
                <div style={{ maxWidth: '1100px', margin: '0 auto' }}>
                    <div
                        style={{
                            background: '#fff',
                            borderRadius: '18px',
                            padding: '24px',
                            boxShadow: '0 10px 24px rgba(15, 23, 42, 0.06)'
                        }}
                    >
                        Загрузка данных заказа...
                    </div>
                </div>
            </div>
        );
    }

    return (
        <div style={{ padding: '24px' }}>
            <div style={{ maxWidth: '1100px', margin: '0 auto' }}>
                <div
                    style={{
                        background: '#ffffff',
                        borderRadius: '20px',
                        padding: '24px',
                        boxShadow: '0 10px 30px rgba(15, 23, 42, 0.08)',
                        marginBottom: '20px'
                    }}
                >
                    <div
                        style={{
                            display: 'flex',
                            justifyContent: 'space-between',
                            alignItems: 'flex-start',
                            gap: '16px',
                            flexWrap: 'wrap'
                        }}
                    >
                        <div>
                            <h2 style={{ margin: '0 0 10px 0', fontSize: '2rem', color: '#111827' }}>
                                Заказ №{orderData.order_id}
                            </h2>
                            <p style={{ margin: '0 0 8px 0', color: '#6b7280' }}>
                                Дата оформления: {orderData.created_at}
                            </p>
                            <p style={{ margin: 0, color: '#111827', fontWeight: '700' }}>
                                Сумма: {orderData.total_price} руб.
                            </p>
                        </div>

                        <div
                            style={{
                                ...getStatusLabelStyle(orderData.status),
                                padding: '10px 14px',
                                borderRadius: '999px',
                                fontWeight: '700',
                                fontSize: '0.95rem'
                            }}
                        >
                            {orderData.status || 'Статус не указан'}
                        </div>
                    </div>
                </div>

                <div
                    style={{
                        background: '#fff',
                        borderRadius: '20px',
                        padding: '24px',
                        boxShadow: '0 10px 24px rgba(15, 23, 42, 0.06)'
                    }}
                >
                    <div
                        style={{
                            display: 'flex',
                            justifyContent: 'space-between',
                            alignItems: 'center',
                            gap: '12px',
                            marginBottom: '18px',
                            flexWrap: 'wrap'
                        }}
                    >
                        <h3 style={{ margin: 0, color: '#111827' }}>Состав заказа</h3>
                        <Link
                            to="/orders"
                            style={{
                                textDecoration: 'none',
                                color: '#2563eb',
                                fontWeight: '700'
                            }}
                        >
                            ← К списку заказов
                        </Link>
                    </div>

                    <div style={{ overflowX: 'auto' }}>
                        <table
                            style={{
                                borderCollapse: 'collapse',
                                width: '100%',
                                minWidth: '700px'
                            }}
                        >
                            <thead>
                                <tr>
                                    <th style={headerCellStyle}>Название</th>
                                    <th style={headerCellStyle}>Бренд</th>
                                    <th style={headerCellStyle}>Цена (руб.)</th>
                                    <th style={headerCellStyle}>Кол-во</th>
                                </tr>
                            </thead>
                            <tbody>
                                {orderData.items.map((item, idx) => (
                                    <tr key={idx}>
                                        <td style={cellStyle}>{item.name}</td>
                                        <td style={cellStyle}>{item.brand}</td>
                                        <td style={cellStyle}>{item.price}</td>
                                        <td style={cellStyle}>{item.quantity}</td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default OrderPage;